import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    pincodeLoader: true,
    areaLoader: true,
    cityLoader: true,
    stateLoader: true,
    countryLoader: true,
    languageLoader: true,
    error: '',
    pincodeDetails: '',
    cityDetails: '',
    stateDetails: '',
    countryDetails: '',
    areaDetails: '',
    languageDetails: ''
};

export default function addressReducer(state = initState, action) {
    switch (action.type) {
        case actions.PINCODE_DETAILS_START: {
            return {
                ...state,
                pincodeLoader: true
            };
        }
        case actions.PINCODE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                pincodeDetails: action.payload,
                pincodeLoader: false,
            };
        }
        case actions.PINCODE_DETAILS_FAILURE: {
            return {
                ...state,
                pincodeLoader: false,
                error: action.message,
            };
        }
        case actions.AREA_DETAILS_START: {
            return {
                ...state,
                areaLoader: true,
            };
        }
        case actions.AREA_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                areaDetails: action.payload,
                areaLoader: false,
            };
        }
        case actions.AREA_DETAILS_FAILURE: {
            return {
                ...state,
                areaLoader: false,
                error: action.message,
            };
        }
        case actions.CITY_DETAILS_START: {
            return {
                ...state,
                cityLoader: true,
            };
        }
        case actions.CITY_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                cityDetails: action.payload,
                cityLoader: false,
            };
        }
        case actions.CITY_DETAILS_FAILURE: {
            return {
                ...state,
                cityLoader: false,
                error: action.message
            };
        }
        case actions.STATE_DETAILS_START: {
            return {
                ...state,
                stateLoader: true,
            };
        }
        case actions.STATE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                stateDetails: action.payload,
                stateLoader: false,
            };
        }
        case actions.STATE_DETAILS_FAILURE: {
            return {
                ...state,
                stateLoader: false,
                error: action.message
            };
        }
        case actions.COUNTRY_DETAILS_START: {
            return {
                ...state,
                countryLoader: true,
            };
        }
        case actions.COUNTRY_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                countryLoader: false,
                countryDetails: action.payload,
            };
        }
        case actions.COUNTRY_DETAILS_FAILURE: {
            return {
                ...state,
                countryLoader: false,
                error: action.message
            };
        }
        case actions.LANGUAGE_DETAILS_START: {
            return {
                ...state,
                languageLoader: true,
            };
        }
        case actions.LANGUAGE_DETAILS_SUCCESS: {
            return {
                ...state,
                languageLoader: false,
                languageDetails: action.payload,
            };
        }
        case actions.LANGUAGE_DETAILS_FAILURE: {
            return {
                ...state,
                languageLoader: false,
                error: action.message
            };
        }
        case actions.CLEAR_ADDRESS_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_ADDRESS_DETAILS_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}